var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { client as braintreeClient, dataCollector, usBankAccount, } from "braintree-web";
import { Result } from "../Result";
import { usePayment } from "../../app/usePayment";
import { useNotifications } from "../../app/useNotifications";
import { useLoader } from "../../app/useLoader";
import { HOSTED_FIELDS_LABEL, HOSTED_FIELDS, renderMaskButtonClasses, } from "../../styles";
import { getAchVaultToken } from "../../services/getAchVaultToken";
export var ACHMask = function (_a) {
    var _b = _a.fullWidth, fullWidth = _b === void 0 ? true : _b, buttonText = _a.buttonText, cartInformation = _a.cartInformation, mandateText = _a.mandateText, getAchVaultTokenURL = _a.getAchVaultTokenURL, useKount = _a.useKount, lineItems = _a.lineItems, shipping = _a.shipping;
    var _c = usePayment(), handlePurchase = _c.handlePurchase, clientToken = _c.clientToken, handleGetVaultedPaymentMethods = _c.handleGetVaultedPaymentMethods, requestHeader = _c.requestHeader;
    var notify = useNotifications().notify;
    var isLoading = useLoader().isLoading;
    var _d = useState([]), limitedVaultedPayments = _d[0], setLimitedVaultedPaymentMethods = _d[1];
    var _e = useState(""), selectedAccount = _e[0], setSelectedAccount = _e[1];
    var _f = useState(true), showVaultedAccounts = _f[0], setShowVaultedAccounts = _f[1];
    var _g = useState(false), showVaultForm = _g[0], setShowVaultForm = _g[1];
    var _h = useState(false), showVaultedMessage = _h[0], setShowVaultedMessage = _h[1];
    var _j = useState(""), accountNumber = _j[0], setAccountNumber = _j[1];
    var _k = useState(""), routingNumber = _k[0], setRoutingNumber = _k[1];
    var _l = useState(""), accountType = _l[0], setAccountType = _l[1];
    var _m = useState(""), ownershipType = _m[0], setOwnershipType = _m[1];
    var _o = useState(""), businessName = _o[0], setBusinessName = _o[1];
    var _p = useState(""), deviceData = _p[0], setDeviceData = _p[1];
    var _q = useState(""), firstName = _q[0], setFirstName = _q[1];
    var _r = useState(""), lastName = _r[0], setLastName = _r[1];
    var _s = useState(""), streetAddress = _s[0], setStreetAddress = _s[1];
    var _t = useState(""), extendedAddress = _t[0], setExtendedAddress = _t[1];
    var _u = useState(""), locality = _u[0], setLocality = _u[1];
    var _v = useState(""), region = _v[0], setRegion = _v[1];
    var _w = useState(""), postalCode = _w[0], setPostalCode = _w[1];
    useEffect(function () {
        var _a = cartInformation.shipping, firstName = _a.firstName, lastName = _a.lastName, streetName = _a.streetName, streetNumber = _a.streetNumber, postalCode = _a.postalCode;
        setFirstName(firstName);
        setLastName(lastName);
        setStreetAddress("".concat(streetName, " ").concat(streetNumber));
        setPostalCode(postalCode);
    }, [cartInformation]);
    var formButtonDisabled = !accountNumber ||
        !routingNumber ||
        !accountType ||
        !ownershipType ||
        !streetAddress ||
        !extendedAddress ||
        !locality ||
        !region ||
        !postalCode;
    if (ownershipType === "business") {
        formButtonDisabled = formButtonDisabled || !businessName;
    }
    else {
        formButtonDisabled = formButtonDisabled || !firstName || !lastName;
    }
    useEffect(function () {
        var filteredPaymentMethods = [];
        handleGetVaultedPaymentMethods().then(function (paymentMethods) {
            paymentMethods.forEach(function (paymentMethod) {
                if (paymentMethod.type === "UsBankAccount") {
                    filteredPaymentMethods.push({
                        nonce: paymentMethod.nonce,
                        details: paymentMethod.details,
                    });
                }
            });
            setLimitedVaultedPaymentMethods(filteredPaymentMethods);
        });
    }, [clientToken]);
    var handleSubmit = function (e) {
        e.preventDefault();
        if (formButtonDisabled)
            return;
        isLoading(true);
        var bankDetails = {
            accountNumber: accountNumber,
            routingNumber: routingNumber,
            accountType: accountType,
            ownershipType: ownershipType,
            billingAddress: {
                streetAddress: streetAddress,
                extendedAddress: extendedAddress,
                locality: locality,
                region: region,
                postalCode: postalCode,
            },
        };
        if (ownershipType === "personal") {
            bankDetails.firstName = firstName;
            bankDetails.lastName = lastName;
        }
        else {
            bankDetails.businessName = businessName;
        }
        braintreeClient.create({
            authorization: clientToken,
        }, function (clientErr, clientInstance) {
            if (clientErr) {
                notify("Error", "Error creating client ".concat(clientErr.message));
                isLoading(false);
                return;
            }
            usBankAccount.create({
                client: clientInstance,
            }, function (usBankAccountErr, usBankAccountInstance) {
                if (usBankAccountErr) {
                    notify("Error", "There was an error creating the USBankAccount instance.");
                    isLoading(false);
                    throw usBankAccountErr;
                }
                dataCollector.create({
                    client: clientInstance,
                    paypal: true,
                    kount: useKount !== null && useKount !== void 0 ? useKount : undefined,
                }, function (dataCollectorErr, dataCollectorInstance) {
                    if (!dataCollectorErr && dataCollectorInstance) {
                        setDeviceData(dataCollectorInstance.deviceData);
                    }
                });
                usBankAccountInstance.tokenize({
                    bankDetails: bankDetails,
                    mandateText: mandateText,
                }, function (tokenizeErr, tokenizedPayload) {
                    return __awaiter(this, void 0, void 0, function () {
                        var vaultResponse, vaultToken;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (tokenizeErr) {
                                        notify("Error", "There was an error tokenizing the bank details, ".concat(tokenizeErr));
                                        isLoading(false);
                                        throw tokenizeErr;
                                    }
                                    return [4 /*yield*/, getAchVaultToken(requestHeader, getAchVaultTokenURL, tokenizedPayload.nonce)];
                                case 1:
                                    vaultResponse = _a.sent();
                                    vaultToken = (vaultResponse || {}).token;
                                    if (vaultToken) {
                                        setShowVaultedMessage(true);
                                        setShowVaultForm(false);
                                    }
                                    else {
                                        notify("Error", "There is an error in vaulting the bank account.");
                                    }
                                    isLoading(false);
                                    return [2 /*return*/];
                            }
                        });
                    });
                });
            });
        });
    };
    var changeAccount = function (e) {
        var value = e.target.value;
        setSelectedAccount(value);
    };
    var handleVaultedPurchase = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isLoading(true);
                    return [4 /*yield*/, handlePurchase(selectedAccount, {
                            deviceData: deviceData,
                            lineItems: lineItems,
                            shipping: shipping,
                        })];
                case 1:
                    _a.sent();
                    isLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [showVaultedMessage === true && (_jsx(Result, { success: true, message: "Account vaulted successfully, as soon as the bank verifies it you can use it as a payment method." })), showVaultedAccounts === true && (_jsxs(_Fragment, { children: [!!limitedVaultedPayments.length && (_jsx("div", __assign({ className: "block w-full" }, { children: limitedVaultedPayments.map(function (vaultedMethod, index) {
                            return (_jsxs("div", __assign({ className: "flex gap-x-5 justify-start content-center border p-2 border-gray-300 rounded my-4" }, { children: [_jsx("input", { className: "w-3 justify-self-center", id: "credit-card-".concat(index), type: "radio", name: "select-credit-card", value: vaultedMethod.nonce, onChange: changeAccount }), _jsxs("label", __assign({ htmlFor: "credit-card-".concat(index), className: "cursor-pointer w-full" }, { children: [_jsx("span", __assign({ className: HOSTED_FIELDS_LABEL }, { children: vaultedMethod.details.accountType })), _jsxs("span", __assign({ className: HOSTED_FIELDS_LABEL }, { children: ["******", vaultedMethod.details.lastFour] })), _jsx("span", __assign({ className: HOSTED_FIELDS_LABEL }, { children: vaultedMethod.details.routingNumber }))] }))] }), index));
                        }) }))), selectedAccount !== "" && (_jsx("div", { children: _jsx("button", __assign({ onClick: handleVaultedPurchase, className: renderMaskButtonClasses(fullWidth, true, false) }, { children: buttonText })) })), _jsx("button", __assign({ onClick: function () {
                            setShowVaultForm(true);
                            setShowVaultedAccounts(false);
                            setSelectedAccount("");
                        }, className: "mt-4" }, { children: "+ Vault new bank account" }))] })), showVaultForm === true && (_jsxs("form", __assign({ className: "m-auto p-8 max-w-screen-md", onSubmit: handleSubmit }, { children: [_jsx("label", __assign({ className: HOSTED_FIELDS_LABEL, htmlFor: "routing-number" }, { children: "Routing Number" })), _jsx("input", { type: "text", id: "routing-number", className: "".concat(HOSTED_FIELDS, " px-3"), value: routingNumber, onChange: function (_a) {
                            var target = _a.target;
                            return setRoutingNumber(target.value);
                        }, required: true }), _jsx("label", __assign({ className: HOSTED_FIELDS_LABEL, htmlFor: "account-number" }, { children: "Account Number" })), _jsx("input", { type: "text", id: "account-number", className: "".concat(HOSTED_FIELDS, " px-3"), value: accountNumber, onChange: function (_a) {
                            var target = _a.target;
                            return setAccountNumber(target.value);
                        }, required: true }), _jsx("label", __assign({ className: HOSTED_FIELDS_LABEL, htmlFor: "account-type" }, { children: "Account Type" })), _jsxs("select", __assign({ id: "account-type", className: "".concat(HOSTED_FIELDS, " px-3"), value: accountType, onChange: function (_a) {
                            var target = _a.target;
                            return setAccountType(target.value);
                        }, required: true }, { children: [_jsx("option", __assign({ value: "" }, { children: "Select" })), _jsx("option", __assign({ value: "checking" }, { children: "Checking" })), _jsx("option", __assign({ value: "savings" }, { children: "Savings" }))] })), _jsx("label", __assign({ className: HOSTED_FIELDS_LABEL, htmlFor: "ownership-number" }, { children: "Ownership Type" })), _jsxs("select", __assign({ id: "ownership-type", className: "".concat(HOSTED_FIELDS, " px-3"), value: ownershipType, onChange: function (_a) {
                            var target = _a.target;
                            return setOwnershipType(target.value);
                        }, required: true }, { children: [_jsx("option", __assign({ value: "" }, { children: "Select" })), _jsx("option", __assign({ value: "personal" }, { children: "Personal" })), _jsx("option", __assign({ value: "business" }, { children: "Business" }))] })), ownershipType === "business" && (_jsxs(_Fragment, { children: [_jsx("label", __assign({ className: HOSTED_FIELDS_LABEL, htmlFor: "business-name" }, { children: "Business Name" })), _jsx("input", { type: "text", id: "business-name", className: "".concat(HOSTED_FIELDS, " px-3"), value: businessName, onChange: function (_a) {
                                    var target = _a.target;
                                    return setBusinessName(target.value);
                                }, required: true })] })), ownershipType === "personal" && (_jsxs("div", __assign({ className: "flex gap-3" }, { children: [_jsxs("div", __assign({ className: "flex-1" }, { children: [_jsx("label", __assign({ className: HOSTED_FIELDS_LABEL, htmlFor: "first-name" }, { children: "First Name" })), _jsx("input", { type: "text", id: "first-name", className: "".concat(HOSTED_FIELDS, " px-3"), value: firstName, onChange: function (_a) {
                                            var target = _a.target;
                                            return setFirstName(target.value);
                                        }, required: true })] })), _jsxs("div", __assign({ className: "flex-1" }, { children: [_jsx("label", __assign({ className: HOSTED_FIELDS_LABEL, htmlFor: "last-name" }, { children: "Last Name" })), _jsx("input", { type: "text", id: "last-name", className: "".concat(HOSTED_FIELDS, " px-3"), value: lastName, onChange: function (_a) {
                                            var target = _a.target;
                                            return setLastName(target.value);
                                        }, required: true })] }))] }))), _jsxs("div", __assign({ className: "flex gap-3" }, { children: [_jsxs("div", __assign({ className: "flex-1" }, { children: [_jsx("label", __assign({ className: HOSTED_FIELDS_LABEL, htmlFor: "street-address" }, { children: "Street Address" })), _jsx("input", { type: "text", id: "street-address", className: "".concat(HOSTED_FIELDS, " px-3"), value: streetAddress, onChange: function (_a) {
                                            var target = _a.target;
                                            return setStreetAddress(target.value);
                                        }, required: true })] })), _jsxs("div", __assign({ className: "flex-1" }, { children: [_jsx("label", __assign({ className: HOSTED_FIELDS_LABEL, htmlFor: "extended-address" }, { children: "Extended Address" })), _jsx("input", { type: "text", id: "extended-address", className: "".concat(HOSTED_FIELDS, " px-3"), value: extendedAddress, onChange: function (_a) {
                                            var target = _a.target;
                                            return setExtendedAddress(target.value);
                                        }, required: true })] }))] })), _jsxs("div", __assign({ className: "flex gap-3" }, { children: [_jsxs("div", __assign({ className: "flex-1" }, { children: [_jsx("label", __assign({ className: HOSTED_FIELDS_LABEL, htmlFor: "locality" }, { children: "Locality" })), _jsx("input", { type: "text", id: "locality", className: "".concat(HOSTED_FIELDS, " px-3"), value: locality, onChange: function (_a) {
                                            var target = _a.target;
                                            return setLocality(target.value);
                                        }, required: true })] })), _jsxs("div", __assign({ className: "flex-1" }, { children: [_jsx("label", __assign({ className: HOSTED_FIELDS_LABEL, htmlFor: "region" }, { children: "Region" })), _jsx("input", { type: "text", id: "region", className: "".concat(HOSTED_FIELDS, " px-3"), value: region, onChange: function (_a) {
                                            var target = _a.target;
                                            return setRegion(target.value);
                                        }, required: true })] }))] })), _jsx("label", __assign({ className: HOSTED_FIELDS_LABEL, htmlFor: "postal-code" }, { children: "Postal Code" })), _jsx("input", { type: "text", id: "postal-code", className: "".concat(HOSTED_FIELDS, " px-3"), value: postalCode, onChange: function (_a) {
                            var target = _a.target;
                            return setPostalCode(target.value);
                        }, required: true }), _jsx("div", __assign({ className: "block text-center" }, { children: _jsx("input", { type: "submit", className: renderMaskButtonClasses(fullWidth, !formButtonDisabled, formButtonDisabled), value: "Vault Bank Account", id: "submit" }) }))] })))] }));
};
